export const WORK_ORDER_STATUS = {
  NEW: 'new',
  VOID: 'void',
  ACCEPTED: 'accepted',
  COMPLETED: 'completed',
  REQUIRES_QUOTE: 'requires_quote',
  REQUIRES_REVISION: 'requires_revision',
  PENDING_APPROVAL: 'pending_approval',
  SCHEDULED: 'scheduled',
  APPROVED: 'approved',
  UNKNOWN: 'unknown',
} as const

export const WORK_ORDER_SCHEDULE_TYPES = {
  UNSCHEDULED: 'unscheduled',
  SINGLE_DAY: 'single_day',
  MULTI_DAY: 'multi_day',
} as const
